import { createContext } from 'react';

import { ModalContextValue } from './modal.type';

/**
 * The context object only. The provider lives in `modal-provider.tsx`.
 *
 * Split so the hooks layer stops inheriting the provider's render tree: `use-process-form`
 * and `use-bulk-process-navigation` need nothing but this object, while the provider renders
 * the action modals and so drags four whole feature trees in through `ACTION_MODALS`
 * (B2B-2147). A convenience `export { ModalProvider } from './modal-provider'` here would
 * restore that edge — the figures are in the PR and the ticket, the invariant is here.
 *
 * It also broke cycles: `process-import-csv`, `process-offline-sales` and both hooks above
 * import this specifier back, which used to resolve to the provider.
 */
export const ModalContext = createContext<ModalContextValue>({
  currentModalType: '',
  toggleModal: () => {},
  setPreventExit: () => {},
  handleCloseModal: () => {},
});
